import GetShopArticlesByDigitalAssetIdRequestModelBase from '../_generated/modelBases/get-shop-articles-by-digital-asset-id-request-model-base';

export default class GetShopArticlesByDigitalAssetIdRequestModel extends GetShopArticlesByDigitalAssetIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
